module.exports = __webpack_public_path__ + "img/btn/button-secondary-hover.png";


//////////////////
// WEBPACK FOOTER
// ./img/btn/button-secondary-hover.png
// module id = 25
// module chunks = 3